__turbopack_context__.v({
  "account": "BuildyWorkspace-module__PlLHPq__account",
  "accountPerson": "BuildyWorkspace-module__PlLHPq__accountPerson",
  "accountPopover": "BuildyWorkspace-module__PlLHPq__accountPopover",
  "activationFields": "BuildyWorkspace-module__PlLHPq__activationFields",
  "addWebsite": "BuildyWorkspace-module__PlLHPq__addWebsite",
  "agentConnection": "BuildyWorkspace-module__PlLHPq__agentConnection",
  "agentGuidance": "BuildyWorkspace-module__PlLHPq__agentGuidance",
  "agentGuidanceText": "BuildyWorkspace-module__PlLHPq__agentGuidanceText",
  "agentPreview": "BuildyWorkspace-module__PlLHPq__agentPreview",
  "avatar": "BuildyWorkspace-module__PlLHPq__avatar",
  "brand": "BuildyWorkspace-module__PlLHPq__brand",
  "brandRobot": "BuildyWorkspace-module__PlLHPq__brandRobot",
  "brandRow": "BuildyWorkspace-module__PlLHPq__brandRow",
  "brandWordmark": "BuildyWorkspace-module__PlLHPq__brandWordmark",
  "canvas": "BuildyWorkspace-module__PlLHPq__canvas",
  "cardActions": "BuildyWorkspace-module__PlLHPq__cardActions",
  "closeNav": "BuildyWorkspace-module__PlLHPq__closeNav",
  "content": "BuildyWorkspace-module__PlLHPq__content",
  "context": "BuildyWorkspace-module__PlLHPq__context",
  "contextIcon": "BuildyWorkspace-module__PlLHPq__contextIcon",
  "contextName": "BuildyWorkspace-module__PlLHPq__contextName",
  "contextPanel": "BuildyWorkspace-module__PlLHPq__contextPanel",
  "contextTrigger": "BuildyWorkspace-module__PlLHPq__contextTrigger",
  "creditHistory": "BuildyWorkspace-module__PlLHPq__creditHistory",
  "creditTable": "BuildyWorkspace-module__PlLHPq__creditTable",
  "currentVersion": "BuildyWorkspace-module__PlLHPq__currentVersion",
  "details": "BuildyWorkspace-module__PlLHPq__details",
  "emptyPagesTable": "BuildyWorkspace-module__PlLHPq__emptyPagesTable",
  "error": "BuildyWorkspace-module__PlLHPq__error",
  "filterReset": "BuildyWorkspace-module__PlLHPq__filterReset",
  "focused": "BuildyWorkspace-module__PlLHPq__focused",
  "historyActionGroup": "BuildyWorkspace-module__PlLHPq__historyActionGroup",
  "historyEmpty": "BuildyWorkspace-module__PlLHPq__historyEmpty",
  "historyIntro": "BuildyWorkspace-module__PlLHPq__historyIntro",
  "historyNotice": "BuildyWorkspace-module__PlLHPq__historyNotice",
  "historyTable": "BuildyWorkspace-module__PlLHPq__historyTable",
  "listContent": "BuildyWorkspace-module__PlLHPq__listContent",
  "main": "BuildyWorkspace-module__PlLHPq__main",
  "menuDivider": "BuildyWorkspace-module__PlLHPq__menuDivider",
  "mobileBar": "BuildyWorkspace-module__PlLHPq__mobileBar",
  "nav": "BuildyWorkspace-module__PlLHPq__nav",
  "navigationOpen": "BuildyWorkspace-module__PlLHPq__navigationOpen",
  "openableRow": "BuildyWorkspace-module__PlLHPq__openableRow",
  "pageActionGroup": "BuildyWorkspace-module__PlLHPq__pageActionGroup",
  "pageActions": "BuildyWorkspace-module__PlLHPq__pageActions",
  "pageEdit": "BuildyWorkspace-module__PlLHPq__pageEdit",
  "pageHeading": "BuildyWorkspace-module__PlLHPq__pageHeading",
  "pageMenuTrigger": "BuildyWorkspace-module__PlLHPq__pageMenuTrigger",
  "pageName": "BuildyWorkspace-module__PlLHPq__pageName",
  "pagePath": "BuildyWorkspace-module__PlLHPq__pagePath",
  "pageRowMenu": "BuildyWorkspace-module__PlLHPq__pageRowMenu",
  "pageStatus": "BuildyWorkspace-module__PlLHPq__pageStatus",
  "pagesBlank": "BuildyWorkspace-module__PlLHPq__pagesBlank",
  "pagesEmpty": "BuildyWorkspace-module__PlLHPq__pagesEmpty",
  "pagesFooter": "BuildyWorkspace-module__PlLHPq__pagesFooter",
  "pagesNotice": "BuildyWorkspace-module__PlLHPq__pagesNotice",
  "pagesPanel": "BuildyWorkspace-module__PlLHPq__pagesPanel",
  "pagesTable": "BuildyWorkspace-module__PlLHPq__pagesTable",
  "pagesTableScroll": "BuildyWorkspace-module__PlLHPq__pagesTableScroll",
  "pagesToolbar": "BuildyWorkspace-module__PlLHPq__pagesToolbar",
  "panel": "BuildyWorkspace-module__PlLHPq__panel",
  "panelBody": "BuildyWorkspace-module__PlLHPq__panelBody",
  "panelHeading": "BuildyWorkspace-module__PlLHPq__panelHeading",
  "previousVersion": "BuildyWorkspace-module__PlLHPq__previousVersion",
  "scrim": "BuildyWorkspace-module__PlLHPq__scrim",
  "search": "BuildyWorkspace-module__PlLHPq__search",
  "settingsSections": "BuildyWorkspace-module__PlLHPq__settingsSections",
  "setupClose": "BuildyWorkspace-module__PlLHPq__setupClose",
  "setupDialog": "BuildyWorkspace-module__PlLHPq__setupDialog",
  "setupNotice": "BuildyWorkspace-module__PlLHPq__setupNotice",
  "setupOverlay": "BuildyWorkspace-module__PlLHPq__setupOverlay",
  "shell": "BuildyWorkspace-module__PlLHPq__shell",
  "sidebar": "BuildyWorkspace-module__PlLHPq__sidebar",
  "sidebarBottom": "BuildyWorkspace-module__PlLHPq__sidebarBottom",
  "textLink": "BuildyWorkspace-module__PlLHPq__textLink",
});
